<!-- Test Info -->
<div *ngIf="currTest?.id" class="flex flex-row items-center">
  <button mat-button color="primary" [disabled]="!previousTestId"
    [routerLink]="['/working-area', previousTestId, currentSection]">
    <span class="flex items-center gap-1">
      <mat-icon>chevron_left</mat-icon>
      <span class="text-primary-dark font-normal" > Previous&nbsp;Test</span>
    </span>
  </button>

  <div class="flex items-center">
    <mat-divider [vertical]="true" class="divider"></mat-divider>

    <div>
      <span class="font-normal text-primary-dark">Test {{ currTest?.id }}</span>
    </div>

    <mat-divider [vertical]="true" class="divider"></mat-divider>
  </div>

  <!-- Patient Info - Show if patientDetails is available -->
  <div *ngIf="
      patientDetails?.id && ability.canView(ability.subjects.PatientsPage)
    " class="flex items-center">
    <span class="font-bold text-primary-dark pr-3">Patient info</span>

    <button mat-button class="btn-link text-primary-dark" [routerLink]="['/patients/details']" [queryParams]="{
        id: patientDetails?.id
      }">
      <span class="font-normal">ID:{{ patientDetails?.patientId }}</span>
    </button>

    <span class="text-primary-dark px-3">
      <span class="font-normal">Name: {{ patientDetails?.user?.firstName }}</span>
      <span class="font-normal"> {{ patientDetails?.user?.lastName }}</span>
    </span>

    <span class="text-primary-dark px-3">
      <span class="font-normal">Age:{{ patientDetails?.age }}</span>
    </span>

    <span class="font-normal text-primary-dark px-3">
      {{ patientDetails?.gender | titlecase }}
    </span>

    <span class="text-primary-dark px-3">
      <span class="font-normal">BMI:{{ patientDetails?.bmi }}</span>
    </span>
  </div>
  <button mat-button color="primary" [disabled]="!nextTestId"
    [routerLink]="['/working-area', nextTestId, currentSection]">
    <span class="flex items-center gap-1">
      <span class="text-primary-dark font-normal" > Next&nbsp;Test</span>
      <mat-icon>chevron_right</mat-icon>
    </span>
  </button>
</div>
